import { render, staticRenderFns } from "./VoiceReply.vue?vue&type=template&id=1e2f554b&scoped=true"
import script from "./VoiceReply.vue?vue&type=script&lang=js"
export * from "./VoiceReply.vue?vue&type=script&lang=js"
import style0 from "./VoiceReply.vue?vue&type=style&index=0&id=1e2f554b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f554b",
  null
  
)

export default component.exports